<template>
	<div class="divider2"></div>
</template>

<script setup lang="ts">

</script>

<style lang="scss" scoped>
.divider2 {
  border-left:1px solid;
}
</style>